module.exports = __webpack_public_path__ + "static/media/read-and-reflect.d6d72094.png";